import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from './snackbarAction';
import { logOut } from './loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function groupNotificationListRes(response) {
  return {
    type: types.GROUP_NOTIFICATION_LIST,
    response
  };
}

export const groupNotificationList = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/studentgroupcontent';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(groupNotificationListRes(data));
    });
};
